import { useEffect, useState } from 'react';
import { useKeycloak } from "@react-keycloak/web";
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Input, Table } from 'reactstrap';
import ReactFileReader from 'react-file-reader';
//
import axios from 'axios';
import { setMenuSelected } from '../redux/actions/menuActions';
import HandleFoto from './HandleFoto';
import URLEndPointBE from './URLEndPointBE';
import EscapeTxt from './EscapeTxt';
import DeEscapeTxt from './DeEscapeTxt';

function ModifFormVybaveni(props: any) { //props.vybaveni
    const { keycloak, initialized } = useKeycloak();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const viditelnost = useSelector((state: any) => state.miscDicts.viditelnost);
    const rodinyVybaveni = useSelector((state: any) => state.miscDicts.rodinyVybaveni);
    //const pouziti = useSelector((state: any) => state.miscDicts.pouziti);
    //console.log("ModifTable props.edit- T: "+typeof(props.edit)+" / val: "+props.edit)
   
    ////// -BEGIN- DOPLNEK
    const [formId, setFormId] = useState(null); //sent with UpdateVybaveni, BE stamped id on AddVybaveni
    const [formKod, setFormKod] = useState("");
    const [formNazev, setFormNazev] = useState("");
    const [formPopis, setFormPopis] = useState("");
    const [formModifikace, setFormModifikace] = useState("");
    const [formDostupnost, setFormDostupnost] = useState("");
    const [formCenovahladina, setFormCenovahladina] = useState("");
    const [formViditelnost, setFormViditelnost] = useState(1);
    const [formDesign, setFormDesign] = useState("");
    const [formErgonomie, setFormErgonomie] = useState("");
    const [formMaterial, setFormMaterial] = useState("");
    const [formServis, setFormServis] = useState("");
    const [formCertifikat, setFormCertifikat] = useState("");
    //// VYBAVENI_POUZITI 1x
    const [formVybaveniPouziti, setFormVybaveniPouziti] = useState([{rodina_kod: "ORN", pouziti_id: 1, podminka: ""}]);
    let handleFormVybaveniPouzitiChanged = (e: any) =>
    {
        //console.log("handleFormVybaveniPouzitiChanged(to "+e.target.value+")")
        let _newPouziti = [{rodina_kod: e.target.value, pouziti_id: 1, podminka: formVybaveniPouziti[0].podminka}];
        setFormVybaveniPouziti(_newPouziti);
        console.log(_newPouziti);
    }
    //let handleFormPovrchyPouzitiTxtChanged - podm Txt NOT IN USE

    //FOTO NEW !2 now, state: WAITING, INSERT, DELETE
    const [formFotky, setFormFotky] = useState([{id: "", state: "WAITING", type: "", base64: ""}, {id: "", state: "WAITING", type: "", base64: ""}])
    let handlePridatFoto = (i: any, e: any) =>
    {
        let fotky = formFotky.slice();
        //e.base64 size - if larger then popup (file too big)
        let file = e.fileList[0]; //name, type
        let handled_fotka = fotky[i];   
            handled_fotka.state = "INSERT";
            handled_fotka.type = file.type;
            handled_fotka.base64 = e.base64;
        setFormFotky(fotky);  
        console.log("formFotky");
        console.log(formFotky);
    }
    let handleSmazatFoto = (i: any) => {
        let fotky = formFotky.slice();
        let handled_fotka = fotky[i];
            handled_fotka.state = "DELETE";
            handled_fotka.base64 = "";
        setFormFotky(fotky);
        console.log("formFotky");
        console.log(formFotky);
    }
    // -END-

    //Add new Vybaveni funct.
    const AddVybaveni = () => {
        console.log("AddVybaveni() called from ModifFormVybaveni") 
        //        id vv - As NEXTVAL_VYBAVENI stamped on BE
        let _vyb = {   kod: formKod, nazev: formNazev, popis: formPopis, modifikace: formModifikace, dostupnost: formDostupnost, cenovahladina: formCenovahladina, viditelnost: formViditelnost, design: formDesign, ergonomie: formErgonomie, material: formMaterial, servis: formServis, certifikat: formCertifikat }

        //Wrapping obj+vybaveni
        let vybaveni = { vybaveni: _vyb, vybaveni_pouziti: formVybaveniPouziti }
        console.log("vybaveni")
        console.log(vybaveni)

        let _succ = true;
        let id_vybaveni = 0;
        //@ts-ignore                                                                                vv - Possibly null
        axios.post(URLEndPointBE+`/new/vybaveni`, vybaveni, { headers: {"Authorization" : `bearer ${keycloak.token}`, 'Content-Type': 'application/json'}})
            .then(function(response) {
                console.log("Vybaveni - Insert SUCC")
                console.log(response.data);
                id_vybaveni = response.data.info;
            })
            .then(() => {
                console.log("then")
                formFotky.forEach(function (foto, i)
                {
                    console.log("foreach")
                    if(foto.state=="INSERT") {
                        console.log("insert")
                        console.log(foto)
                        let _foto = {id: null, poradi: (i+1), prvek_id: formId, prvek_kod: formKod, soubor:"Prv_00.jpg", typ: foto.type, image_base64: (foto.base64).replace("data:"+foto.type+";base64,","") };
                        //@ts-ignore                                                                         vv - Possibly null
                        axios.post(URLEndPointBE+`/new/foto`, _foto, { headers: {"Authorization" : `bearer ${keycloak.token}`, 'Content-Type': 'application/json'}})
                            .then(() => {
                                console.log("Foto"+(i+1)+" - Insert SUCC")
                            })
                            .catch(function(error) {
                                console.log(error);
                                _succ = false;
                            })
                    }
                });
            })
            .catch(function(error) {
                console.log(error);
                _succ = false;
            })
            console.log("redirecting")
            if(_succ) {
                console.log("navigating, _succ: true")
                setTimeout(function() {
                    navigate('/vybaveni', {state: {succ: true, type: 'VLOZENI', item: 'VYBAVENI'}});
                }, 1500);
            }   
    }  

    //Update existing Vybaveni
    const UpdateVybaveni = () => {
        console.log("UpdatePovrch() called from ModifFormPovrch")

        let updateVyb = {id: formId, kod: formKod, nazev: formNazev, popis: formPopis, modifikace: formModifikace, dostupnost: formDostupnost, cenovahladina: formCenovahladina, viditelnost: formViditelnost, design: formDesign, ergonomie: formErgonomie, material: formMaterial, servis: formServis, certifikat: formCertifikat }
        
        let updateVybaveni = { vybaveni: updateVyb, vybaveni_pouziti: formVybaveniPouziti }
        
        console.log("updateVybaveni")
        console.log(updateVybaveni)
        console.log("response - /vybaveni/formId")
        let _succ = true;
        //@ts-ignore                                                                                         vv - Possibly null
        axios.put(URLEndPointBE+`/vybaveni/`+formId, updateVybaveni, { headers: {"Authorization" : `bearer ${keycloak.token}`, 'Content-Type': 'application/json'}})
            .then(function(response) {
                console.log(response.data);
            })
            .then(() => {
                formFotky.forEach(function (foto, i)
                {
                    switch(foto.state) {
                        case 'INSERT':
                            //UPDATE FOTO/id (poradi=i+1)
                            if(foto.id!=="") {
                                let _foto = {id: null, poradi: (i+1), prvek_id: formId, prvek_kod: formKod, soubor:"Prv_00.jpg", typ: foto.type , image_base64: (foto.base64).replace("data:"+foto.type+";base64,","") };
                                //@ts-ignore                                                                           vv - Possibly null
                                axios.put(URLEndPointBE+`/update/foto`, _foto, { headers: {"Authorization" : `bearer ${keycloak.token}`, 'Content-Type': 'application/json'}})
                                .then(() => {
                                    console.log("Foto"+(i+1)+" - Update SUCC")
                                })
                                .catch(function(error) {
                                    console.log(error);
                                    _succ = false;
                                 })
                            //INSERT FOTO
                            } else {
                                let _foto = {id: null, poradi: (i+1), prvek_id: formId, prvek_kod: formKod, soubor:"Prv_00.jpg", typ: foto.type, image_base64: (foto.base64).replace("data:"+foto.type+";base64,","") };
                                //@ts-ignore                                                                         vv - Possibly null
                                axios.post(URLEndPointBE+`/new/foto`, _foto, { headers: {"Authorization" : `bearer ${keycloak.token}`, 'Content-Type': 'application/json'}})
                                .then(() => {
                                    console.log("Foto"+(i+1)+" - Insert SUCC")
                                })
                                .catch(function(error) {
                                    console.log(error);
                                    _succ = false;
                                })
                            }
                            break;
                        case 'DELETE':
                            //DELETE id
                            if(foto.id!=="") {
                                //@ts-ignore                                                                                vv - Possibly null
                                axios.delete(URLEndPointBE+`/delete/foto/`+foto.id, { headers: {"Authorization" : `bearer ${keycloak.token}`, 'Content-Type': 'application/json'}})
                                .then(() => {
                                    console.log("Foto"+(i+1)+" - DELETE SUCC")
                                })
                                .catch(function(error) {
                                    console.log(error);
                                    _succ = false;
                                })
                            }
                            break;
                        default:
                            console.log("default")
                            break;
                    }
                });
            })  
            .catch(function(error) {
                console.log(error);
                _succ=false;
            })
            console.log("redirecting")
            if(_succ) {
                console.log("navigating, _succ: true")
                setTimeout(function() {
                    navigate('/vybaveni/vybaveni/'+formId, {state: {succ: true, type: 'EDITACE', item: 'VYBAVENI'}});
                }, 1500);
            }  
    }
    
    useEffect(() => {
        //FetchRodinyPovrchu(); //What
        dispatch(setMenuSelected("vybaveni"));
        console.log("useEffect()")
        //WTF jaktoze tady neni fetch axios.get EP na rodiny (rodiny ciselnik i guess)
        if(props.edit) {
            console.log("props.vybaveni dump")
            console.log(props.vybaveni)

            setFormId(props.vybaveni.id)
            setFormKod(DeEscapeTxt(props.vybaveni.kod))
            setFormNazev(DeEscapeTxt(props.vybaveni.nazev))
            let fotky = props.vybaveni.foto?.reduce((listFotky: any, fotka: any) => ([...listFotky, {id: fotka.fotoId, state:"VIEWING", type: null, base64: null}]), [])
            let fotky2 = [];
            //HOTFIX when foto: null
            if(props.vybaveni.foto!==null) {
                for(let i = 0; i < 2; ++i) {
                    if(fotky[i]!==undefined) {
                     fotky2[i] = fotky[i]
                 } else {
                        fotky2[i] = {id: "", state: "WAITING", type: "", base64: ""};
                    }
                }
            } else {
                fotky2[0] = {id: "", state: "WAITING", type: "", base64: ""};  
                fotky2[1] = {id: "", state: "WAITING", type: "", base64: ""};  
            }
            setFormFotky(fotky2)
            console.log("fotky2")
            console.log(fotky2)
            //setFormVybaveniPouziti->click MOD
            //console.log("vybaveniPouziti[0] attempt")
            //console.log(props.vybaveni.vybaveniPouziti)
            setFormVybaveniPouziti(props.vybaveni.vybaveniPouziti)
            //console.log(formVybaveniPouziti)
            //setFoto(props.vybaveni.foto)
            setFormViditelnost(props.vybaveni.viditelnost)
            setFormModifikace(DeEscapeTxt(props.vybaveni.modifikace))
            setFormPopis(DeEscapeTxt(props.vybaveni.popis))
            setFormDesign(DeEscapeTxt(props.vybaveni.design))
            setFormErgonomie(DeEscapeTxt(props.vybaveni.ergonomie))
            setFormMaterial(DeEscapeTxt(props.vybaveni.material))
            setFormServis(DeEscapeTxt(props.vybaveni.servis))
            setFormDostupnost(DeEscapeTxt(props.vybaveni.dostupnost))
            setFormCertifikat(DeEscapeTxt(props.vybaveni.certifikat))
            setFormCenovahladina(DeEscapeTxt(props.vybaveni.cenovahladina))
        }
    }, [])
    return (<Container>
        <div>
            <Table hover>
                <thead>
                    <tr>
                        <th className='justWrap'><span className="katBtnStyle ptHover" onClick={() => {navigate(-1)}} > &lt; ZPĚT </span></th>
                        <th>VYBAVENI</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th className='justWrap'>KOD</th>
                        <td>
                            <Input
                                type="textarea"
                                value={(formKod) ? formKod : ""}
                                onChange={(e: any) => {setFormKod(e.target.value)}}
                            />
                        </td>
                    </tr>
                    <tr>
                        <th className='justWrap'>NAZEV</th>
                        <td>
                            <Input
                                type="textarea"
                                value={(formNazev) ? formNazev : ""}
                                onChange={(e: any) => {setFormNazev(e.target.value)}}
                            />
                        </td>
                    </tr>
                    <tr>
                        <th scope="row" className='justWrap'>POUZITI</th>
                        <td className={"tableWrapCenter"}>
                            <table>
                                <tbody>
                                    <tr>
                                        <td>
                                            <label>
                                                {/*selected on load flag*/}
                                                <select onChange={(e) => {handleFormVybaveniPouzitiChanged(e)}} value={formVybaveniPouziti[0].rodina_kod}> {/*[{rodina_kod: null, pouziti_id: null}]*/}
                                                    {/*rodinyVybaveni already mapped, call function to make selection here*/}
                                                    {rodinyVybaveni.map((rod: any) =>
                                                    <option key={rod.id} value={rod.kod}>{rod.kod}</option>)}
                                                </select>
                                            </label>
                                        </td>
                                        {/*<td>
                                            <Input
                                                className={'filterInputStyle'}
                                                value={"asd"}
                                                onChange={(e: any) => {console.log("zavolat nejaky handle(rod, poznamka)")}}
                                            />
                                        </td>*/}
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row" className='justWrap'>VZOREK</th>
                        <td>
                            <div className={'wrapperFoto'}>
                                {formFotky.map( (foto: any, i) => <span>
                                    <HandleFoto i={i} foto={foto} handle_pridat_foto={handlePridatFoto} handle_smazat_foto={handleSmazatFoto}/>
                                </span> )}
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row" className='justWrap'>VIDITELNOST</th>
                        <td>
                            <select onChange={(e: any) => {setFormViditelnost(e.target.value)}} value={formViditelnost}>
                                {viditelnost.map((vid: any) =>
                                <option key={vid.key} value={vid.key}>{vid.value}</option>)}
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row" className='justWrap'>MODIFIKACE</th>
                        <td>
                            <Input
                                type="textarea"
                                value={(formModifikace) ? formModifikace : ""}
                                onChange={(e: any) => {setFormModifikace(e.target.value)}}
                            />
                        </td>
                    </tr>
                    <tr>
                        <th scope="row" className='justWrap'>POPIS</th>
                        <td>
                            <Input
                                type="textarea"
                                value={(formPopis) ? formPopis : ""}
                                onChange={(e: any) => {setFormPopis(e.target.value)}}
                            />
                        </td>
                    </tr>
                    <tr>
                        <th scope="row" className='justWrap'>DESIGN</th>
                        <td>
                            <Input
                                type="textarea"
                                value={(formDesign) ? formDesign : ""}
                                onChange={(e: any) => {setFormDesign(e.target.value)}}
                            />
                        </td>
                    </tr>
                    <tr>
                        <th scope="row" className='justWrap'>ERGONOMIE</th>
                        <td>
                            <Input
                                type="textarea"
                                value={(formErgonomie) ? formErgonomie : ""}
                                onChange={(e: any) => {setFormErgonomie(e.target.value)}}
                            />
                        </td>
                    </tr>
                    <tr>
                        <th scope="row" className='justWrap'>MATERIAL</th>
                        <td>
                            <Input
                                type="textarea"
                                value={(formMaterial) ? formMaterial : ""}
                                onChange={(e: any) => {setFormMaterial(e.target.value)}}
                            />
                        </td>
                    </tr>
                    <tr>
                        <th scope="row" className='justWrap'>SERVIS</th>
                        <td>
                            <Input
                                type="textarea"
                                value={(formServis) ? formServis : ""}
                                onChange={(e: any) => {setFormServis(e.target.value)}}
                            />
                        </td>
                    </tr>
                    <tr>
                        <th scope="row" className='justWrap'>DOSTUPNOST</th>
                        <td>
                            <Input
                                type="textarea"
                                value={(formDostupnost) ? formDostupnost : ""}
                                onChange={(e: any) => {setFormDostupnost(e.target.value)}}
                            />
                        </td>
                    </tr>
                    <tr>
                        <th scope="row" className='justWrap'>CERTIFIKAT</th>
                        <td>
                            <Input
                                type="textarea"
                                value={(formCertifikat) ? formCertifikat : ""}
                                onChange={(e: any) => {setFormCertifikat(e.target.value)}}
                            />
                        </td>
                    </tr>
                    <tr>
                        <th scope="row" className='justWrap'>CENOVA HLADINA</th>
                        <td>
                            <Input
                                type="textarea"
                                value={(formCenovahladina) ? formCenovahladina : ""}
                                onChange={(e: any) => {setFormCenovahladina(e.target.value)}}
                            />
                        </td>
                    </tr>
                </tbody>
            </Table>
            { (props.edit)
              ? <span className="katBtnStyle ptHover" onClick={() => {UpdateVybaveni()}}> AKTUALIZOVAT </span>
              : <span className="katBtnStyle ptHover" onClick={() => {AddVybaveni()}}> PŘIDAT </span>}
            <span>&nbsp;</span>
            <p>&nbsp;</p>
        </div>
    </Container>)
}
export default ModifFormVybaveni